import * as Yup from 'yup';

import { FormikHelpers, FormikValues } from 'formik';

import { ApiHelper } from '../../../helpers';
import { Axios } from 'axios';
import { FunctionComponent } from 'react';
import { SearchSelectField } from '../../../components';
import { StatusCodes } from 'http-status-codes';
import { TecnicosLotacaoFormType } from '../../../types';
import { TipoGrupoEleitoresEnum } from '../../../enums';
import { useTranslation } from 'react-i18next';
import { useUnidadesAcademicas } from '../../../hooks';

export const initialValuesTecnicosLotacaoForm = (t: Function) => ({
  selectedForm: t('label.tecnicos_administrativos_por_lotacao'),
  unidade: '',
});

export const validationSchemaTecnicosLotacaoForm = (t: Function) =>
  Yup.object().shape({ unidade: Yup.number().required(t('validacao.campo_obrigatorio')) });

export const onSubmitTecnicosLotacaoForm =
  (t: Function, axios: Axios, setResultado: Function, setLoading: Function, setErrorStatus: Function, errorHandler: Function) =>
  (values: FormikValues, formikHelpers: FormikHelpers<FormikValues>) => {
    setLoading(true);
    axios
      .get(ApiHelper.getUrl.apiSCE.buscaEleitores(TipoGrupoEleitoresEnum.TECNICO_ADMINISTRATIVO), {
        params: {
          consulta: 'LOTACAO',
          unidade: values.unidade,
        },
      })
      .then((response) => {
        setResultado(response.data);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response.status === StatusCodes.NOT_FOUND) {
          setErrorStatus(error.response.status);
        } else {
          errorHandler(error, t('erro.recuperar_eleitores'));
        }
      })
      .finally(() => {
        formikHelpers.setSubmitting(false);
      });
  };

const TecnicosLotacaoForm: FunctionComponent<TecnicosLotacaoFormType> = ({ formikProps }) => {
  const { t } = useTranslation();
  const unidades = useUnidadesAcademicas(null);

  return (
    <SearchSelectField
      label={t('label.unidade_lotacao')}
      name="unidade"
      formikProps={formikProps}
      options={unidades}
      required
    />
  );
};

export default TecnicosLotacaoForm;
